import React, { useEffect, useMemo, useState } from "react";
import styles from "./orders.module.scss";
import axios from "axios";
import cx from "classnames";
import * as moment from "moment-timezone";
import { useNavigate } from "@reach/router";
import NumberFormat from "react-number-format";
import toast, { Toaster } from "react-hot-toast";

export default function OrdersPage() {
  const [orders, setOrders] = useState([]);
  const [ordersFiltered, setOrdersFiltered] = useState([]);
  const [completada, setCompletada] = useState(0);
  const [pendiente, setPendiente] = useState(0);
  const [activeTab, setActiveTab] = useState("");
  const api = process.env.REACT_APP_API;
  const navigate = useNavigate();

  useEffect(() => {
    let menu = false;
    if (localStorage.getItem("products")) {
      menu = true;
    }
    refresh(menu);
  }, []);

  useEffect(() => {
    if (activeTab === "" && orders.length > 0) {
      setActiveTab("restaurant");
    }
  }, [orders]);

  useEffect(() => {
    if (activeTab === "restaurant") {
      console.log(orders);
      setOrdersFiltered(
        orders.filter(
          (list) =>
            list.delivery === undefined &&
            list.thirdDelivery !== true &&
            list.isPickUp !== true &&
            list.pickUp === undefined &&
            list.isOwnDelivery !== true
        )
      );
    } else {
      setOrdersFiltered(
        orders.filter(
          (list) =>
            list.delivery !== undefined ||
            list.thirdDelivery === true ||
            list.isPickUp === true ||
            list.isOwnDelivery === true ||
            list.pickUp
        )
      );
    }
  }, [activeTab]);

  const refresh = (_menu = false) => {
    const promise = axios
      .get(`${api}order/all`, {
        params: {
          business: process.env.REACT_APP_BUSINESS,
          start: moment()
            .startOf("day")
            .tz("America/El_Salvador")
            .tz("UTC")
            .format("YYYY-MM-DD HH:mm:ss"),
          end: moment()
            .endOf("day")
            .tz("America/El_Salvador")
            .tz("UTC")
            .format("YYYY-MM-DD HH:mm:ss"),
        },
      })
      .then(({ data }) => {
        let pendienteCount = 0;
        let completadaCount = 0;
        console.log(data);
        let ordersList = data.map((d) => {
          let grossProfitTemp = 0;

          if (d.status.name === "Pendiente") {
            pendienteCount += d.total;
          }

          if (d.status.name === "Completada") {
            completadaCount += d.total;
          }

          return {
            ...d,
            grossProfit: grossProfitTemp,
          };
        });
        setPendiente(pendienteCount);
        setCompletada(completadaCount);
        setOrders(ordersList);
      });

    if (_menu) {
      menu();
    }

    toast.promise(promise, {
      loading: "Cargando...",
      success: "Carga completada!",
      error: "Uh oh, there was an error!",
    });
  };

  const getExtraName = (order) => {
    if (order.thirdDelivery) {
      return `: DELIVERY APPs`;
    }

    if (order.delivery || order.isOwnDelivery) {
      return `: DELIVERY PROPIO`;
    }

    if (order.placement) {
      return `: ${order.placement.name}`;
    }

    if (order.pickUp) {
      return `: RECOGER EN EL LOCAL`;
    }

    if (order.isPickUp) {
      return `: PARA LLEVAR`;
    }
  };

  const menu = () => {
    axios
      .get(
        `${api}category/all?type=item&business=${process.env.REACT_APP_BUSINESS}`
      )
      .then(({ data }) => {
        localStorage.setItem("categories", JSON.stringify(data));
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(`${api}item/all`, {
        params: {
          business: process.env.REACT_APP_BUSINESS,
        },
        headers: {
          Authorization: `Bearer ${window.sessionStorage.getItem("token")}`,
        },
      })
      .then(({ data }) => {
        localStorage.setItem("products", JSON.stringify(data));
      })
      .catch((e) => {
        console.log(e.response);
      });

    axios
      .get(`${api}placement/all`, {
        params: {
          business: process.env.REACT_APP_BUSINESS,
        },
        headers: {
          Authorization: `Bearer ${window.sessionStorage.getItem("token")}`,
        },
      })
      .then(({ data }) => {
        localStorage.setItem("placements", JSON.stringify(data));
      })
      .catch((e) => {
        console.log(e.response);
      });
  };

  const delivery = useMemo(() => {
    return orders.filter(
      (list) =>
        (list.delivery !== undefined ||
          list.thirdDelivery === true ||
          list.isPickUp === true ||
          list.isOwnDelivery === true ||
          list.pickUp) &&
        list.status.name !== "Completada"
    ).length;
  }, [orders]);

  const restaurant = useMemo(() => {
    return orders.filter(
      (list) =>
        list.delivery === undefined &&
        list.thirdDelivery !== true &&
        list.isPickUp !== true &&
        list.pickUp === undefined &&
        list.isOwnDelivery !== true &&
        list.status.name !== "Completada"
    ).length;
  }, [orders]);

  return (
    <div>
      <div className={styles.total}>
        Pendiente:{" "}
        <span className={styles.pendiente}>
          <NumberFormat
            value={pendiente}
            displayType={"text"}
            thousandSeparator={true}
            prefix={"$"}
            fixedDecimalScale={true}
            decimalScale={2}
          />
        </span>
        , Completada:{" "}
        <span className={styles.completada}>
          <NumberFormat
            value={completada}
            displayType={"text"}
            thousandSeparator={true}
            prefix={"$"}
            fixedDecimalScale={true}
            decimalScale={2}
          />
        </span>
      </div>
      <div className={styles.tabs}>
        <div
          onClick={() => setActiveTab("restaurant")}
          className={cx(activeTab === "restaurant" && styles.active)}
        >
          Restaurante <span>{restaurant}</span>
        </div>
        <div
          onClick={() => setActiveTab("delivery")}
          className={cx(activeTab === "delivery" && styles.active)}
        >
          Delivery/Recoger en Local/Para Llevar <span>{delivery}</span>
        </div>
      </div>
      <div className={styles.orders}>
        {ordersFiltered.map((order) => {
          return (
            <div
              className={cx(
                styles.existingOrder,
                order.status.name !== "Completada" && styles.noComplete,
                order.status.name === "Cancelada" && styles.cancelada,
                order.status.name === "Pendiente de Aprobación" &&
                  styles.pendienteAprobacion
              )}
              onClick={() => {
                navigate(
                  `/order/${order._id}/${
                    order.status.name !== "Completada" ? "edit" : "view"
                  }`
                );
              }}
              key={order._id}
            >
              <div className={styles.number}>
                #{order.id}
                {getExtraName(order)}
                {order.client && (
                  <div className={styles.client}>
                    Cliente: {order.client.name}
                  </div>
                )}
              </div>
              <div className={styles.placement}></div>
              <div className={styles.total}>
                <NumberFormat
                  value={order.total}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"$"}
                  fixedDecimalScale={true}
                  decimalScale={2}
                />
              </div>
            </div>
          );
        })}
        <div
          className={styles.addOrder}
          onClick={() => {
            navigate(`/order/`);
          }}
        >
          Agregar Orden
        </div>
        <div className={styles.refresh} onClick={() => refresh(true)}>
          <i className="far fa-sync"></i>
        </div>
      </div>
    </div>
  );
}
